export enum CustomRequestStatus {
    ASSIGNED = 'ASSIGNED',
    SEEN = 'SEEN',
    IN_PROGRESS = 'IN_PROGRESS',
    ON_HOLD = 'ON_HOLD',
    CLOSED = 'CLOSED'
}